import { render, staticRenderFns } from "./addproduct.vue?vue&type=template&id=16d29a66&scoped=true&"
import script from "./addproduct.vue?vue&type=script&lang=js&"
export * from "./addproduct.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addproduct.vue?vue&type=style&index=1&id=16d29a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d29a66",
  null
  
)

export default component.exports